import { styled } from '@grupoboticario/flora-react';

export const SideMenuList = styled('ul', {
  listStyle: 'none',
  overflow: 'auto',
  height: 'calc(100vh - 110px)'
});

export const SideHeader = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '87px',
  left: '0px',
  top: '0px',
  background: '#364372',
  justifyContent: 'revert',
  padding: '0 10px',
  '& svg': {
    margin: '10px 15px 0px 0px'
  }, 
  marginBottom: '20px'
});

export const IconButton = styled('div', {
  cursor: 'pointer'
});
export const SubItemMenu = styled('li', {});
export const LinkMenu = styled('a', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '20px 30px 20px 20px',
    height: '56px',
    '&:hover': {
        color: '#3873B8'  
    },
    '& div': {
      paddingRight: '10px'
    },
    fontSize: '16px'
});
